export const DialogStates = {
  SelectActorToReferTo: 'SelectActorToReferTo',
  SelectServicesWithActor: 'SelectServicesWithActor',
  WriteMessageToActor: 'WriteMessageToActor',
  DoYouWantToWriteMessageToCustomerPrompt: 'DoYouWantToWriteMessageToCustomerPrompt',
  WriteMessageToCustomer: 'WriteMessageToCustomer',
  DoYouWantToArchivePrompt: 'DoYouWantToArchivePrompt',
} as const;

export type DialogState = keyof typeof DialogStates;
